module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAAAzmf///yH5BAAHAP8ALAAAAAAMAAwAAAIXhI+pGu0cTIMypgkwwvpwu1ldRS7maRQAOw=="